import React from "react";

const IncreaseArrow = () => {
  return (
    <svg
      width="28"
      height="33"
      viewBox="0 0 28 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5841_42360)">
        <path
          d="M0.300816 14.1217C0.400181 14.2195 0.51913 14.2971 0.650549 14.3499C0.781967 14.4027 0.923153 14.4296 1.06566 14.4289H6.67353C6.88367 14.4289 7.0852 14.5089 7.23378 14.6512C7.38237 14.7935 7.46585 14.9865 7.46585 15.1878V31.9836C7.46585 32.2532 7.57765 32.5117 7.77665 32.7023C7.97565 32.8929 8.24555 32.9999 8.52698 32.9999H19.4427C19.7241 32.9999 19.9941 32.8929 20.1931 32.7023C20.3921 32.5117 20.5038 32.2532 20.5038 31.9836V15.1878C20.5038 14.9865 20.5873 14.7935 20.7359 14.6512C20.8845 14.5089 21.086 14.4289 21.2962 14.4289H26.9196C27.1325 14.4328 27.3416 14.3754 27.5199 14.264C27.6981 14.1526 27.8373 13.9924 27.9193 13.8043C28.0013 13.6162 28.0223 13.4088 27.9797 13.209C27.937 13.0093 27.8326 12.8265 27.68 12.6843L14.7527 0.303622C14.6547 0.207472 14.5377 0.131063 14.4084 0.0788932C14.2792 0.0267234 14.1403 -0.000152588 14.0001 -0.000152588C13.8598 -0.000152588 13.721 0.0267234 13.5917 0.0788932C13.4625 0.131063 13.3454 0.207472 13.2475 0.303622L0.320865 12.6843C0.119343 12.8724 0.0040373 13.1295 0.000277979 13.399C-0.00348135 13.6685 0.104614 13.9284 0.300816 14.1217Z"
          fill="#3B873E"
        />
      </g>
      <defs>
        <clipPath id="clip0_5841_42360">
          <rect width="28" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const DecreaseArrow = () => {
  return (
    <svg
      width="28"
      height="33"
      viewBox="0 0 28 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5841_42423)">
        <path
          d="M27.6992 18.8783C27.5999 18.7805 27.4809 18.7029 27.3495 18.6501C27.2181 18.5973 27.0769 18.5704 26.9344 18.5711L21.3265 18.5711C21.1164 18.5711 20.9149 18.4911 20.7663 18.3488C20.6177 18.2065 20.5342 18.0135 20.5342 17.8122L20.5342 1.01638C20.5342 0.746837 20.4224 0.488334 20.2234 0.297736C20.0244 0.107139 19.7545 6.4129e-05 19.4731 6.41044e-05L8.55734 6.31501e-05C8.27591 6.31255e-05 8.00601 0.107138 7.80701 0.297735C7.60801 0.488333 7.49621 0.746836 7.49621 1.01638L7.49621 17.8122C7.49621 18.0135 7.41273 18.2065 7.26415 18.3488C7.11556 18.4911 6.91403 18.5711 6.70389 18.5711L1.08043 18.5711C0.867612 18.5672 0.658477 18.6246 0.480199 18.736C0.301921 18.8474 0.162742 19.0076 0.0807431 19.1957C-0.00125575 19.3838 -0.0222843 19.5912 0.0203907 19.791C0.0630657 19.9907 0.167468 20.1735 0.320039 20.3157L13.2474 32.6964C13.3453 32.7925 13.4624 32.8689 13.5916 32.9211C13.7209 32.9733 13.8597 33.0002 14 33.0002C14.1402 33.0002 14.2791 32.9733 14.4083 32.9211C14.5376 32.8689 14.6546 32.7925 14.7526 32.6964L27.6792 20.3157C27.8807 20.1276 27.996 19.8705 27.9998 19.601C28.0035 19.3315 27.8954 19.0716 27.6992 18.8783Z"
          fill="#E31B0C"
        />
      </g>
      <defs>
        <clipPath id="clip0_5841_42423">
          <rect
            width="28"
            height="33"
            fill="white"
            transform="translate(28 33) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export { DecreaseArrow, IncreaseArrow };
